module.exports = "footer {\n  margin-top: 20px;\n  padding-top: 10px;\n  color: #5382a1;\n  background-color: #1d4059; }\n"